import CatalogLayout from "../../../../layout/app/admin/CatalogLayout";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../ElevatedPaper";

const ProviderCatalog = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)" }}>
      <CatalogLayout />
    </ElevatedPaper>
  );
};

export default ProviderCatalog;
